/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { memo, useCallback } from 'react';
import shortid from 'shortid';
import { handleADA } from '@dsg-tech/homefield-utils';
import {
  HomefieldIconArrowBackspace,
  HomefieldIconTimeHistory,
} from '@dsg-tech/homefield-react-icons';
import { SearchState } from '../types/index';

type Props = {
  searchHistoryResults: SearchState['searchHistoryResults'];
  submitSearch: (term: string, type: string) => void;
  searchFromSuggestion: (term: string, type: string) => void;
  updateSearchTermSAYT: (term: string) => void;
  clickSuggestedTerm: (type: string) => void;
};

const SuggestionHistoryResults = ({
  searchHistoryResults,
  submitSearch,
  searchFromSuggestion,
  updateSearchTermSAYT,
  clickSuggestedTerm,
}: Props) => {
  const handleHistoryClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, keyword: string): void => {
      e.preventDefault();
      clickSuggestedTerm('Recent');
      window.location.href = submitSearch(keyword, 'Recent');
    },
    [clickSuggestedTerm, submitSearch],
  );
  return (
    <>
      {searchHistoryResults && searchHistoryResults.length > 0
        ? searchHistoryResults.map((keyword: string) => {
            return (
              <div
                key={shortid()}
                data-testid="sayt-suggested-history"
                className="dsg-search-suggestion-result-container">
                <button
                  type="button"
                  className="dsg-search-suggestion-result hmf-text-align-left hmf-subheader-l hmf-subheader-m-m"
                  onMouseEnter={() => searchFromSuggestion(keyword, 'Recent')}
                  onFocus={() => searchFromSuggestion(keyword, 'Recent')}
                  onClick={(e) => handleHistoryClick(e, keyword)}>
                  <HomefieldIconTimeHistory
                    width="19px"
                    height="16px"
                    viewBox="0 0 19 16"
                    xmlns="http://www.w3.org/2000/svg"
                    className="history-icon"
                  />
                  <span className="dsg-search-suggestion-keyword">{keyword}</span>
                </button>
                <strong
                  role="button"
                  onClick={() => updateSearchTermSAYT(keyword)}
                  onKeyPress={(e) => handleADA(e, 'button', updateSearchTermSAYT(keyword))}
                  aria-label="arrow button">
                  <HomefieldIconArrowBackspace height="15px" width="15px" />
                </strong>
              </div>
            );
          })
        : ''}
    </>
  );
};

export default memo(
  SuggestionHistoryResults,
  (prev, next) => prev.searchHistoryResults === next.searchHistoryResults,
);
